import { ComponentChildren } from 'preact'
import { useCallback } from 'preact/hooks'
import { useLongPress } from '../../../hooks'
import { StorableBarcode, type StorableItem } from '../../../store/ResultItemsListStore'
import { classnames } from '../../../utils'
import styles from './index.module.css'

export function ListItem({
  item,
  highlighted,
  onLongPress,
  onReleasePress,
}: {
  item: StorableItem
  highlighted: boolean
  onLongPress: (info: StorableItem) => void
  onReleasePress: (info: StorableItem) => void
}) {
  const _onLongPress = useCallback(
    (_: EventTarget) => {
      onLongPress(item)
    },
    [item, onLongPress]
  )

  const _onReleasePress = useCallback(
    (_: EventTarget) => {
      onReleasePress(item)
    },
    [item, onReleasePress]
  )
  const listeners = useLongPress(_onLongPress, _onReleasePress, 350)
  const isBarcode = item instanceof StorableBarcode
  return (
    <li class={classnames({ [styles.highlighted]: highlighted })} {...listeners}>
      <div>
        <div class={styles.data}>
          {item.data} {isBarcode && <span class={styles.addOnData}>{item.addOnData}</span>}
        </div>
        <div class={styles.symbology}>{isBarcode ? item.symbologyDescription.readableName : item.fieldName}</div>
      </div>
      <div class={styles.quantity}>{item.quantity.value > 1 ? `Qty ${item.quantity.value}` : ''}</div>
    </li>
  )
}

export function BarcodeList({ children }: { children: ComponentChildren }) {
  return <ul class={styles.barcodeList}>{children}</ul>
}
